import * as Tool from '../tool'
/**
 * 地图撒点
 * @param {String} id 图层id
 * @param {String} img 图片名称+后缀
 * @param {Object} data 撒点数据 geojson
 * @param {Object} option 撒点配置项
 * @param {Object} cluster 是否聚合
 */

function addPoint(id, img, data, option = {}, cluster = false) {
  const mapbox = this.mapbox
  const imgUrl = './map/image/' + img
  const source = id + '-source'
  const iconImage = id + '-image' // 图片名称
  let opt = {
    jump: true,
    clusterMaxZoom: 16, // 最大缩放到群集点
    clusterRadius: 16, //聚类点时每个聚类的半径（默认为50）
    iconSize: 36, // 非聚合图标大小，单位为像素
    clusterIconSize: 1.5, // 聚合图标大小，原图放大的倍数
    textOffset: [0, 30], // 文本的偏移
    textColor: '#ffffff', // 文本的颜色
    delay: 500
  }
  // 覆盖属性
  opt = Object.assign(opt, option)
  // 异步加载图片
  mapbox.loadImage(imgUrl, (error, image) => {
    let h = opt.iconSize / image.width
    image.width = opt.iconSize
    image.height = h * image.height
    if (!mapbox.hasImage(iconImage)) {
      // 添加至数据源
      mapbox.addImage(iconImage, image)
    }

    // 若存在，删除
    if (mapbox.getSource(source)) {
      mapbox.getSource(source).setData(data)
    } else {
      if (!cluster) {
        // 添加撒点数据源
        mapbox.addSource(source, {
          type: 'geojson',
          data
        })
      } else {
        // 聚合数据源
        mapbox.addSource(source, {
          type: 'geojson',
          data,
          cluster: true,
          clusterMaxZoom: 16 | opt.clusterMaxZoom,
          clusterRadius: 50 | opt.clusterRadius
        })
      }
    }
    if (!mapbox.getLayer(id)) {
      // 添加非聚类图层
      // type的形状值：[fill, line, symbol, circle, heatmap, fill-extrusion, raster, hillshade, background]
      mapbox.addLayer({
        id: id,
        type: 'symbol',
        source,
        paint: {
          'icon-opacity': 0
        },
        layout: {
          'icon-image': iconImage,
          'icon-allow-overlap': true,
          'icon-size': 1 //设置图片显示的大小
        }
      })
    }
    let animate = new Tool.Animate(mapbox, {
      frame: 20,
      delay: opt.delay
    })
    animate.putPaint(id, 'icon-opacity', 0, 1).start()
    // 是否跳转
    if (opt.jump) {
      mapbox.on('click', id, e => {
        mapbox.flyTo({
          center: e.features[0].geometry.coordinates,
          zoom: 16,
          speed: 1,
          curve: 1.5,
          easing(t) {
            return t
          }
        })
      })
    }
    if (cluster) {
      mapbox.addLayer({
        id: clusterId,
        type: 'symbol',
        source,
        filter: ['has', 'point_count'],
        layout: {
          'icon-image': iconImage,
          'icon-offset': opt.offset | [0, 30], //设置偏移量
          'icon-size': opt.clusterIconSize | 1.5, //设置图片显示的大小
          'text-field': '{point_count_abbreviated}',
          'text-font': ['Microsoft YaHei Regular'],
          'text-size': opt.fontSize | 22
        },
        paint: {
          'text-color': opt.textColor | '#F4FA3C'
        }
      })
    }
  })
}
export default addPoint



// WEBPACK FOOTER //
// ./src/framework/map/layer/Point.js